import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style/LandingPage.scss';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <div className="overlay"></div>
      
      <div className="content">
        <h1 className="landing-title">Welcome to Our Amazing Platform</h1>
        
        <p className="landing-description">
          Dive into a world of opportunities and watch your business soar!
        </p>
        
        <div className="button-container">
          <button 
            className="owner-button" 
            onClick={() => navigate('/Owner-Home')}
          >
            OWNER
          </button>
          
          <button 
            className="retailer-button" 
            onClick={() => navigate('/Retailer-Home')}
          >
            RETAILER
          </button>
          
          <button 
            className="consumer-button" 
            onClick={() => navigate('/consumer')}
          >
            CONSUMER
          </button>
        </div>
        
        <div className="additional-content">
          <h2>Why Choose Us?</h2>
          
          <p>Here's why our platform stands out:</p>
          
          <div className="feature-list">
            <div className="feature-item">
              <span className="feature-icon">🚀</span>
              <span className="feature-text">Advanced analytics to supercharge your strategies</span>
            </div>
            
            <div className="feature-item">
              <span className="feature-icon">💡</span>
              <span className="feature-text">Seamless integration with top eCommerce platforms</span>
            </div>
            
            <div className="feature-item">
              <span className="feature-icon">📞</span>
              <span className="feature-text">Exceptional support to guide you every step</span>
            </div>
          </div>
          
          <p className="cta-text">Ready to embark on this journey? Click one of the buttons above!</p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;